import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { AssetDto, AssetStatus, GalleryDto } from '@nusign/picflow-backend-types';
import { Subject, takeUntil } from 'rxjs';
import { AbsPipe } from '../../../pipes/abs.pipe';
import { AssetService } from '../../../services/asset.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { AssetStatusButtonColorPipe } from '../../pipes/asset-status-button-color.pipe';
import { AssetStatusIconPipe } from '../../pipes/asset-status-icon.pipe';
import { AssetStatusNamePipe } from '../../pipes/asset-status-name.pipe';
import { GalleryIsApproveOnlyPipe } from '../../pipes/gallery-is-approve-only.pipe';
import { AssetStatusButtonExtraContextComponent } from '../asset-status-button-extra-context/asset-status-button-extra-context.component';

@Component({
  selector: 'app-asset-status-button',
  templateUrl: './asset-status-button.component.html',
  styleUrl: './asset-status-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonDirective,
    SvgComponent,
    ContextMenuComponent,
    AssetStatusButtonExtraContextComponent,
    AssetStatusButtonColorPipe,
    AssetStatusNamePipe,
    AssetStatusIconPipe,
    TranslatePipe,
    AbsPipe,
    TooltipDirective,
    GalleryIsApproveOnlyPipe,
  ],
})
export class AssetStatusButtonComponent implements OnInit, OnDestroy {
  private assetService = inject(AssetService);
  private check = inject(ChangeDetectorRef);
  @Input({ required: true }) gallery: GalleryDto;
  @Input({ required: true }) asset: AssetDto;
  @Input({ required: true }) location: string;
  @Input() approvedAssetCount: number;
  @Input() small: boolean;
  @Input() tiny: boolean;
  @Input() advancedMode: boolean;
  @Input() defaultColor: string;
  @Input() displayOnly: boolean;
  @Output() onSelectStatus = new EventEmitter<AssetStatus>();
  destroyed$ = new Subject<void>();

  ngOnInit(): void {
    this.assetService.updates.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.check.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
